import { Form, Input, Tooltip } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../../components/DraggableModal";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { aliasText } from "../../../../../utils";

enum FormField {
    alias,
    nameRu,
    nameKy,
}
interface IProps {
    show: boolean;
    leasingProject: EntDirectoryInfoName;
    onHide: () => void;
    onSubmit: (pos: EntDirectoryInfoName) => Promise<boolean>;
}

export const AddLeasingProjectModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.alias, value: props.leasingProject.alias },
            { name: FormField.nameKy, value: props.leasingProject.nameKy },
            { name: FormField.nameRu, value: props.leasingProject.nameRu },
        ]);
    }

    const setEntityFromFields = (): EntDirectoryInfoName => {
        let res = _.cloneDeep(props.leasingProject);
        res.alias = form.getFieldValue(FormField.alias);
        res.nameKy = form.getFieldValue(FormField.nameKy);
        res.nameRu = form.getFieldValue(FormField.nameRu);
        return res;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.leasingProject.id === 0 ? t('mechanisation.leasing_operator.add_leasing_operator') : t('mechanisation.leasing_operator.edit_leasing_operator')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Tooltip title={aliasText} >
                        <Form.Item
                          label={t('general.alias')}
                          name={FormField.alias}
                          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                        >
                            <Input maxLength={255} showCount autoComplete="off" />
                        </Form.Item>
                    </Tooltip>
                    <Form.Item
                        label={ t('general.nameKy') }
                        name={FormField.nameKy}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                    <Form.Item
                        label={ t('general.nameRu') }
                        name={FormField.nameRu}
                        rules={ [ { required: true, message: t("msg.fill_in_the_field") } ] }
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                </Form>
            </DraggableModal>

        </>

    )
}
